var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgError({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.4043 18.6064C14.3749 18.6064 18.4043 14.577 18.4043 9.60645C18.4043 4.63588 14.3749 0.606445 9.4043 0.606445C4.43373 0.606445 0.404297 4.63588 0.404297 9.60645C0.404297 14.577 4.43373 18.6064 9.4043 18.6064ZM8.3543 4.63647H10.4403L10.4263 10.6285H8.3683L8.3543 4.63647ZM7.8783 13.1625C7.8783 12.3505 8.5363 11.7485 9.4183 11.7485C10.2863 11.7485 10.9303 12.3505 10.9303 13.1625C10.9303 13.9605 10.2863 14.5765 9.4183 14.5765C8.5363 14.5765 7.8783 13.9605 7.8783 13.1625Z",
    fill: "#FF5454"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.84ed53e47e3fab23340841e8d63012d0.svg";
export { ForwardRef as ReactComponent };